import { render, staticRenderFns } from "./ModalGenerateSettlements.vue?vue&type=template&id=03528dc0&scoped=true&lang=pug"
import script from "./ModalGenerateSettlements.vue?vue&type=script&lang=js"
export * from "./ModalGenerateSettlements.vue?vue&type=script&lang=js"
import style0 from "./ModalGenerateSettlements.vue?vue&type=style&index=0&id=03528dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03528dc0",
  null
  
)

export default component.exports